module.exports = __webpack_public_path__ + "49d9b23371b52b3b4f7c6a28212eaf3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/administering-eternity-2011.jpg
// module id = 884
// module chunks = 0